import { Component, inject, OnDestroy } from '@angular/core';
import { provideNativeDateAdapter } from '@angular/material/core';
import { RouterLink } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SignalsStoreService } from '../../signals-store.service';

@Component({
  selector: 'app-pending-payment-method-no-signup',
  providers: [provideNativeDateAdapter()],
  imports: [RouterLink],
  template: `
  <div class="container">
    <div class="row">
      <div class="col mb-3 text-center">
        <small>
          We noticed an issue with the payment method on file. This may be due to an expired card, a billing address change, or a simple processing error. To continue shopping with ease, please update your card details. Thank you!        
        </small>
      </div>
    </div>

    <div class="row mt-0 mb-2 justify-content-center">
      <div class="col-md-auto">
        <button
          type="button"
          class="btn btn-primary"
          (click)="activeModal.close()"
          [routerLink]="'settings/billing/payment-method'">
          Update Payment Method
        </button>
      </div>
    </div>
  </div>
`
})
export class PendingPaymentMethodNoSignupComponent implements OnDestroy {
  activeModal = inject(NgbActiveModal);
  #signalStoreService = inject(SignalsStoreService);

  constructor() {
    this.#signalStoreService.requirePaymentMethodOpened.set(true);
  }

  ngOnDestroy(): void {
    this.#signalStoreService.requirePaymentMethodOpened.set(false);
  }
}
